

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ImplantApi } from '../api/implant.api';
import { switchMap, map } from 'rxjs/operators';
import { ImplantData, Implant } from '../../../interfaces/masters/implant';

@Injectable()
export class ImplantService extends ImplantData {

  constructor(private api: ImplantApi) {
    super();
  }
  list(url: string): Observable<Implant[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Implant>{
      return this.api.getById(url);
  }

  create(url: string, data:Implant): Observable<Implant> {
    return this.api.add(url,data);
  }

  update(url: string, data:Implant): Observable<Implant> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
